




































































import { Component, Vue } from "vue-property-decorator";
import { FETCH_CPT_TYPES } from "@/store/actions-types";
import { CPTTypeModelI } from "@/models/cpt/CPTTypeModel";
import { GET_CPT_TYPES, GET_IS_ANON } from "@/store/getters-types";

@Component
/**
 * The main page where users land first
 * Allows to choose a cpt anon users would like to create
 */
export default class Home extends Vue {
  /**
   *Helper to decide if we show the error message
   */
  public cptsFetched = false;

  /**
   * keep the cpt path reference
   * when asking user to start over
   */
  public tmpCptPath: string | null = null;

  /**
   * Fetch the available custom post types initially
   */
  async mounted(): Promise<void> {
    await this.$store.dispatch(FETCH_CPT_TYPES);
    this.cptsFetched = true;
  }

  /**
   * redirect to create cpt
   * if already editing one, ask for confirmation
   */
  createCPT(cptPath: string): void {
    if (!this.$store.getters[GET_IS_ANON]) {
      this.$router.push({ name: "createCPT", params: { cpt: cptPath } });
    } else {
      this.$bvModal.show("prevent-start-over-modal");
      this.tmpCptPath = cptPath;
    }
  }

  /**
   * get the cpt types from the store
   */
  get cpts(): CPTTypeModelI[] {
    return this.$store.getters[GET_CPT_TYPES];
  }
}
